import Vue from 'vue'
import appCache from '../publish/cache/app.json'

/*
 * CONFIGURATIONS
 */
const translations = process.env.VUE_APP_LANGUAGES.split(',')
const moduleName = 'check-position'
const carrierEndpoint = process.env.VUE_APP_STORAGE_API

/*
 * VENDORS
 */
import axiosPlugin from './vendor/axios'
import cookiePlugin from './vendor/cookie'
import localstoragePlugin from './vendor/localstorage'
import stripePlugin from './vendor/stripe'
import momentPlugin from './vendor/moment'
import vueRecaptchaV3Plugin from './vendor/vue-recaptcha-v3'
import vueTheMaskPlugin from './vendor/vue-the-mask'
import vuetifyPlugin from './vendor/vuetify'

export const axios = Vue.prototype.$axios = axiosPlugin()
export const cookie = Vue.prototype.$cookie = cookiePlugin()
export const ls = Vue.prototype.$ls = localstoragePlugin()
export const stripe = Vue.prototype.$stripe = stripePlugin({ ls })
export const moment = Vue.prototype.$moment = momentPlugin()
export const recaptcha3 = vueRecaptchaV3Plugin()
export const theMask = vueTheMaskPlugin()
export const vuetify = vuetifyPlugin({ translations })

/*
 * HELPERS
 */
import helpersPlugin from './helpers/index'
export const helpers = Vue.prototype.$helpers = helpersPlugin({ moment })


/*
 * COMMONS
 */
import userInterfacePlugin from './common/user-interface'
import localePlugin from './common/locale'
import eventBusPlugin from './common/event-bus'
import apiPlugin from './common/api'
import modulePlugin from './common/module'
import carrierPlugin from './common/carrier'
import accountPlugin from './common/account'

export const bus = Vue.prototype.$bus = eventBusPlugin()
export const carrier = Vue.prototype.$carrier = carrierPlugin({ endpoint: carrierEndpoint })
export const module = Vue.prototype.$module = modulePlugin({ appCache, module: moduleName })
export const ui = Vue.prototype.$ui = userInterfacePlugin({ appCache, bus })
export const locale = Vue.prototype.$locale = localePlugin({ appCache, moment, cookie, vuetify, translations })
export const api = Vue.prototype.$api = apiPlugin({ appCache, ui,locale,  bus, axios })
export const account = Vue.prototype.$account = accountPlugin({ appCache, locale, ui, ls, api })

/*
 * MODELS
 */
import carrierObjectsPlugin from './models/carrier-objects'
import inputPlugin from './models/input'
import positionPlugin from './models/position'
import subscriptionPlugin from './models/subscription'
import serp from './models/serp/index'

export const models = Vue.prototype.$models = {
  CarrierObjects: carrierObjectsPlugin({ account, moment }),
  Input: inputPlugin(),
  Position: positionPlugin(),
  Subscription: subscriptionPlugin({ api, helpers, moment, module }),
  serp
}

/*
 * REPOSITORIES
 */
import tagsRepository from './repositories/tags'
import notesRepository from './repositories/notes'
import monitorsRepository from './repositories/monitors'
import scheduledExportsRepository from './repositories/scheduled-exports'

export const repos = Vue.prototype.$repos = {
  tags: tagsRepository({ api }),
  notes: notesRepository({ api }),
  monitors: monitorsRepository({ api }),
  scheduledExports: scheduledExportsRepository({ api }),
}

/*
 * SERVICES
 */
import datacenterCheckPlugin from './services/pages/datacenter-check'
import monitoringPlugin from './services/pages/monitoring'
import urlMonitoringPlugin from './services/pages/url-monitoring'
import clickyPlugin from './services/clicky'

export const services = Vue.prototype.$services = {
  monitoring: monitoringPlugin({ bus, account, carrier, moment, api, models, repos }),
  datacenterCheck: datacenterCheckPlugin({ carrier }),
  urlMonitoring: urlMonitoringPlugin({ bus, account, carrier, models, api }),
  clicky: clickyPlugin({ account, ui })
}

/*
 * Others
 */
import autocompletionPlugin from './helpers/old/autocompletion'

export const autocompletion = Vue.prototype.$autocompletion = autocompletionPlugin({ account })
